import React from 'react';
import PropTypes from 'prop-types';

import {_} from 'utils/i18n';

import Option from 'scripts/components/Option';
import Select from 'scripts/components/Select';
import {IDType} from 'utils/prop-types';

const EmptyLabel = _('Not specified');

const ReasonSelect = ({value, abortReasons, onChange}) => (
    <Select value={value} onChange={onChange}>
        <Option value="">{EmptyLabel}</Option>
        {abortReasons.map(({id, value, label}) => (
            <Option key={id} value={value}>{label}</Option>
        ))}
    </Select>
);

export const AbortReasonShape = PropTypes.shape({
    id: IDType.isRequired,
    value: IDType.isRequired,
    label: PropTypes.string.isRequired,
});

ReasonSelect.propTypes = {
    value: IDType.isRequired,
    onChange: PropTypes.func.isRequired,
    abortReasons: PropTypes.arrayOf(AbortReasonShape).isRequired,
};

export default ReasonSelect;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/ReasonSelect.js